import React, { useState, useMemo, useLayoutEffect, useEffect } from "react"; //unused imports
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DashboardSidebar from "../DashboardSidebar/DashboardSidebar";
import DashboardPensionOption from "./DashboardPensionOption/DashboardPensionOption";
import DashboardRestOption from "./DashboardRestOption/DashboardRestOption";
import greenDotIcon from "../../assets/images/green-dot.png";
import greyDot from "../../assets/images/grey-dot.png";
import { GetDepositData } from "../../services/GetDepositData";
import { GetPensionData } from "../../services/GetPensionData";
import DepositData from "../../entities/DepositData";
import PensionData from "../../entities/PensionData";
import { GetAmitRedemptionRights } from "../../services/GetAmitRedemptionRights";
import RedemptionRightData from "../../entities/RedemptionRightData";
import { GetRightsPerEmpJob } from "../../services/GetRightsPerEmpJob";
import RightsPerEmpData from "../../entities/RightsPerEmpData";
import { GetSalaryData } from "../../services/GetSalaryData";
import SalaryData from "../../entities/SalaryData";
import {
  setActiveFund,
  setRedemptionRightDataRedux,
  setShowAmitMobile,
  setShowGimlaiMobile,
} from "../../state/actions/DashboardActions";
import whiteWallet from "../../assets/images/wallet.png";
import walletIcon from "../../assets/images/black-wallet.png";
import walletIconWhite from "../../assets/images/wallet.png";
import UserFund from "../../entities/UserFund";
import backArrowMobile from "../../assets/images/backArrowMobile.svg";

import "./Dashboard.scss";
import useWindowDimensions from "../../customHooks/useWindowDimensions";
import { screenSzie } from "../../utils/main";
import { type } from "os";
import { setSalaryDataRedux, setpensionTypeDesc, setpensionTypeDescHeader, pensionTypeDescCounter} from "../../state/actions/UserActions";
import { setModalChild, setModalState } from "../../state/actions/modalAction";
import ErrorPopup from "../ErrorPopup/ErrorPopup";
import RenderInputError from "../../pages/Login/RenderInputError/RenderInputError";
const Dashboard = () => {
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation("common");
  const { userId, userFunds, isAmit, isPensioner, pensionTypeDescHeader,salaryDataRedux, isFileFound } = useSelector(
    (state: any) => state.UserReducer
  );

  const { activeFund, redemptionRightDataRedux, pensionDataRedux, showAmitFundMobile, showGimlaiFundMobile } = useSelector(
    (state: any) => state.DashboardReducer
  );
 
  const [userDepositData, setDepositData] = useState<DepositData[]>([]);
  const [rightsPerEmp, setRightsPerEmp] = useState<RightsPerEmpData[]>([]);
  const [userSalaryData, setSalaryData] = useState<SalaryData[]>([]);
  const [pensionDesc, setPensionDesc] = useState<any>();

  const { width } = useWindowDimensions();
  const istablete = (width < screenSzie.tablet);

  //  console.log('v4')
  sessionStorage.setItem("fundCode", activeFund?.fundCode);

  // dont delete it will be use in the future 
  const getpensionTypeDesc = (pensionTypeDesc: string) => {
    switch (pensionTypeDesc) {
      case "קרן פנסיה":
        return t("Dashboard.pensionFund");
      case "קצבת זקנה":
        return t("Dashboard.oldAgePension");
      case "קצבת נכות":
        return t("Dashboard.disabilityPension");
      case "שארי מבוטח":
        return t("Dashboard.shariInsured");
      case "שארי פנסיונר":
        return t("Dashboard.shariInsured");
      default:
        return "";
    }
  };


  useLayoutEffect(() => {
    
    async function init() {      
      !Object.keys(activeFund).length && dispatch(setActiveFund(userFunds[0]));
      if (isAmit && isPensioner) {
        initAmitAndPensionerData();
      } else if (isAmit) {
        initAmitData();
      } else if (isPensioner) {
        initPensionerData();
      }
    }
    init();
    return () => {
      // dispatch(setActiveFund({} as UserFund));
      dispatch(setShowAmitMobile(false));
      dispatch(setShowGimlaiMobile(false));
    };
    // eslint-disable-next-line
  }, []);

  //TODO -- Delete GetSalaryData()
  const initPensionerData = async () => {
    const salaryData = salaryDataRedux;
    dispatch(setpensionTypeDesc(salaryData.pensionTypeDesc) )
    dispatch(setSalaryDataRedux(salaryData))
    setSalaryData(salaryData);
  };

  const initAmitData = async () => {
    Promise.all([
      GetRightsPerEmpJob(),
      GetDepositData()
    ]).then((results) => {

      setRightsPerEmp(results[0]);
      setDepositData(results[1])
    }).catch(err => console.log("err", err));

  };

  const initAmitAndPensionerData = async () => {
    Promise.all([
      GetRightsPerEmpJob(),
      GetSalaryData(),
      GetDepositData()
    ]).then((results) => {
      setRightsPerEmp(results[0]);
      setSalaryData(results[1]);
      dispatch(setSalaryDataRedux(results[1]))
      setDepositData(results[2]);
    });
  };

  const lastDeposit = useMemo(() => {

    if (userDepositData?.length && activeFund?.isAmit) {
      const approvalsDeposits = userDepositData.filter(
        (deposit: DepositData) =>
          deposit.fullyAscribed &&
          deposit.fundCode === parseInt(activeFund?.fundCode)
      );
      if (approvalsDeposits.length) return approvalsDeposits[0]; // The deposits list is sorted by latest deposits at first element
    }
    return {} as DepositData;
  }, [userDepositData, activeFund]);

      useMemo(() => {
     
        if (userSalaryData?.length && activeFund?.isPensioner) {
          const result = userSalaryData.reduce((x:any, y:any) => {
            
            (x[y.fundCode] = x[y.fundCode] || []).push(y);
            
            return x;
            
          }, {});
          
          
         const setUserFundName:any = {}
         let fundCount:any = 0
          for (const property in result) {
          const salaryDataDate =  new Date(Math.max(...result[property].map((e:any) => new Date(e.salaryDate))));
          const res =  result[property].filter((salaryData: any) => (new Date(salaryData.salaryDate) >= salaryDataDate && new Date(salaryData.salaryDate) <= salaryDataDate) && salaryData.fundCode  == `${property}`)
          dispatch(pensionTypeDescCounter(res.length))

            if(res.length >= 2){
              setUserFundName[`${res[0].fundCode}`] = `${res[0].pensionTypeDesc} , ${res[1].pensionTypeDesc}`
            }
            else{
              //no data
              setUserFundName[`${res[0].fundCode}`] =  res[0].pensionTypeDesc ? `${res[0].pensionTypeDesc}` : " "
            }          
          }          
         setPensionDesc(setUserFundName)
         dispatch(setpensionTypeDescHeader(setUserFundName))
        } 
      }, [userSalaryData, activeFund]);


  const salaryDataByActiveFund = useMemo(() => {
    if (userSalaryData?.length && activeFund?.isPensioner) {
      return userSalaryData.filter(
        (salaryData: SalaryData) => salaryData.fundCode === activeFund?.fundCode
      );
    }
    return [] as SalaryData[];
  }, [userSalaryData, activeFund]);

  const pensionDataByActiveFund = useMemo(() => {
    if (pensionDataRedux?.length && activeFund?.isAmit) {
      const pensionData = pensionDataRedux.filter(
        (pensionData: PensionData) =>
          pensionData.fundCode === activeFund?.fundCode
      );
      if (pensionData.length) return pensionData[0];
    }
    return {} as PensionData;
  }, [pensionDataRedux, activeFund]);

  const redemptionDataByActiveFund = useMemo(() => {
    if (redemptionRightDataRedux?.length && activeFund?.isAmit) {
      const redemptionData = redemptionRightDataRedux.filter(
        (redemption: RedemptionRightData) =>
          redemption.fundCode === activeFund?.fundCode &&
          redemption.isBalanceTypePension
      );
      if (redemptionData.length) return redemptionData[0];
    }
    return {} as RedemptionRightData;
  }, [redemptionRightDataRedux, activeFund]);

  const unRedemptionDataByActiveFund = useMemo(() => {
    if (redemptionRightDataRedux?.length && activeFund?.isAmit) {
      const redemptionData = redemptionRightDataRedux.filter(
        (redemption: RedemptionRightData) =>
          redemption.fundCode === activeFund?.fundCode &&
          !redemption.isBalanceTypePension
      );
      if (redemptionData.length) return redemptionData[0];
    }
    return {} as RedemptionRightData;
  }, [redemptionRightDataRedux, activeFund]);

  const empRightsByActiveFund = useMemo(() => {
    if (rightsPerEmp?.length && activeFund?.isAmit) {
      return rightsPerEmp.filter(
        (rights: RightsPerEmpData) => rights.fundCode === activeFund?.fundCode
      );
    }
    return [] as RightsPerEmpData[];
  }, [rightsPerEmp, activeFund]);

  const getFundTextIcon = () => {
    const { isPensioner, isActiveFund } = activeFund;
    if (isPensioner) {
      return <img src={walletIcon} width={24} height={24} alt="" />;
    }

    if (isActiveFund) {
      return (
        <div className="dashboard-fund-status-text">
          <span>{t("Sidebar.active")}</span>
          <img src={greenDotIcon} alt="green" width={24} height={24} role="presentation" aria-hidden="true" />
        </div>
      );
    }

    return (
      <div className="dashboard-fund-status-text">
        <span>{t("Sidebar.notActive")}</span>
        <img src={greyDot} alt="grey" role="presentation" aria-hidden="true" />
      </div>
    );
  };

  const getFundStatusIcon = (isWhite?: boolean) => {
    const { isPensioner, isActiveFund } = activeFund;

    if (isPensioner) {
      return <img src={!isWhite ? walletIcon : walletIconWhite} alt="wallet" height={25} width={25} role="presentation" aria-hidden="true" />;
    }

    if (isActiveFund) {
      return <img src={greenDotIcon} alt="green" width={24} height={24} role="presentation" aria-hidden="true" />;
    }

    return <img src={greyDot} alt="grey" width={35} height={35} role="presentation" aria-hidden="true" />;
  };

  const getFundStatusText = () => {
    const { isPensioner, isActiveFund } = activeFund;

    if (isPensioner) {
      return t("general.kitzva");
    }

    if (isActiveFund) {
      return t("Sidebar.active");
    }
    // amit and not active fund ..
    return t("Sidebar.notActive");
  };

  const handleMobileBack = (fromAmit?: boolean) => {
    dispatch(setActiveFund({} as UserFund));
    if (fromAmit) {
      dispatch(setShowAmitMobile(false));
    } else {
      dispatch(setShowGimlaiMobile(false));
    }
  };

  const activeFundLabel = () => {
    return (i18n.language === "ar") ? activeFund?.fundNameArab : activeFund?.fundLabel
  }

  useEffect(() => {
    document.title = (localStorage.getItem("lang") === "ar") ? "amitim " + activeFund?.fundNameArab : "amitim " + activeFund?.fundLabel;
  }, [activeFund]);



  const handleMobileRender = () => {
    // handle the layout of page, if one of the show mobile
    // variable's is true, render the fund page. else in mobile(!) - only show sidebar.
    // else - the regular desktop layout (sidebar => content ..).
    if (showGimlaiFundMobile) {
      return (
        <div className="content-mobile">
          <div className="dashboard-header-text">
            <div className="d-flex justify-content-between align-items-flex-start">
              <div className="d-flex gap-3" >
                <img
                  src={backArrowMobile}
                  alt="back-arrow"
                  onClick={() => handleMobileBack()}
                  className="back-arrow"
                />
                <div className="text-box">
                  <h2 className="header-text" style={{ paddingBottom: "0px" }}>
                    {activeFundLabel()}
                  </h2>
                  {/* <div className="dashboard-title-separator"></div> */}
                  <h3>{pensionDesc ? pensionDesc[activeFund.fundCode] : null}</h3>
                  <span className="dashboard-fund-number">
                    {`${t("Dashboard.fundNumber")} | ${activeFund?.fundCertificateNumber}`}
                  </span>
                </div>
              </div>
              <div className="dashboard-fund-status-text">
                {getFundStatusIcon(true)}
                <div style={{ marginTop: "15px" }}>{getFundStatusText()}</div>
              </div>
            </div>
          </div>

          <DashboardRestOption
            key={"mobile"}
            userSalaryData={salaryDataByActiveFund}
            lastSalaryData={salaryDataByActiveFund[0]}

          />

        </div>
      );
    } else if (showAmitFundMobile) {
      return (
        <div className="content-mobile">
          <div className="dashboard-header-text">
            <div className="d-flex justify-content-between align-items-start">
              <div className="d-flex gap-3" >
                <img
                  src={backArrowMobile}
                  alt="back-arrow"
                  onClick={() => { window.location.reload(); handleMobileBack(true) }}
                  className="back-arrow"
                />
                <div className="text-box">
                  <h2 className="header-text" style={{ paddingBottom: "0px" }}>
                    {activeFundLabel()}
                  </h2>
                  {/* <div className="dashboard-title-separator"></div> */}
                  <h3>{activeFund.isAmit ? `${t("Dashboard.pensionFund")}` : null}</h3>
                  <span className="dashboard-fund-number">
                    {`${t("Dashboard.fundNumber")} | ${activeFund?.fundCertificateNumber}`}
                  </span>
                </div>
              </div>
              <div className="dashboard-fund-status-text">
                {getFundStatusIcon()}
                <div style={{ marginTop: "10px" }}>{getFundStatusText()}</div>
              </div>
            </div>
          </div>

          <DashboardPensionOption
            key={"mobile"}
            lastDeposit={lastDeposit}
            userPensionData={pensionDataByActiveFund}
            redemptionRightData={redemptionDataByActiveFund}
            unRedemptionRightData={unRedemptionDataByActiveFund}
            rightsPerEmp={empRightsByActiveFund}
          />
        </div>
      );
    } else {
      return (
        <DashboardSidebar
          userSalaryData={userSalaryData}
          userPensionData={pensionDataRedux}
          redemptionRightData={redemptionRightDataRedux}
          userDepositData={userDepositData}
          pensionDesc={pensionTypeDescHeader} />
      );
    }
  };

  return (
    
    <div
      className={
        showGimlaiFundMobile || showAmitFundMobile
          ? "dashboard page mobile-page"
          : "dashboard page"
      }
    >
      {handleMobileRender()}

      <main className="content" id="main">
        <div className="dashboard-header-text">
          <h1 style={{ paddingBottom: "0px" }}>
            {activeFundLabel()}
            {/* |&nbsp; */}
          </h1>
          {/* <div className="dashboard-title-separator"></div> */}
          <div className="d-flex align-items-center gap-3">
            <p className="p-lh h3-title">{activeFund?.isPensioner ? pensionDesc && pensionDesc[activeFund.fundCode] : `${t("Dashboard.pensionFund")}`}</p>
            {getFundTextIcon()}
          </div>
          <span className="dashboard-fund-number">
            {`${t("Dashboard.fundNumber")} | ${activeFund?.fundCertificateNumber}`}
          </span>
        </div>
        {activeFund?.isPensioner ? (
          <DashboardRestOption
            key={"desktop"}
            userSalaryData={salaryDataByActiveFund}
            lastSalaryData={salaryDataByActiveFund[0]}
          />
        ) : (
          <DashboardPensionOption
            key={"desktop"}
            lastDeposit={lastDeposit}
            userPensionData={pensionDataByActiveFund}
            redemptionRightData={redemptionDataByActiveFund}
            unRedemptionRightData={unRedemptionDataByActiveFund}
            rightsPerEmp={empRightsByActiveFund}
          />
        )}
      </main>

    </div>
  );
};

export default Dashboard;
